export default "__VITE_ASSET__bPPMyyP0__"